var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React from 'react';
import styled from 'styled-components';
import InputText from '../common/input-text';
export default function CustomNumberings(_a) {
    var value = _a.value, error = _a.error;
    var t = useI18n().t;
    return (_jsxs(Container, { children: [_jsx("p", { children: t('filters.custom-numberings.message') }), _jsx(InputText, { label: t('filters.custom-numerbings.input-label'), onChange: value.bind.onChange, value: value.value }), error && _jsx("p", { className: "error", children: error })] }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  justify-content: flex-start;\n  width: 100%;\n\n  & > p {\n    text-align: center;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  justify-content: flex-start;\n  width: 100%;\n\n  & > p {\n    text-align: center;\n  }\n"])));
var templateObject_1;
